export default __webpack_public_path__ + "static/media/favorite.e34be422.gif";